module.exports = __webpack_public_path__ + "img/待发货.6cc10829.svg";